<template>
  <div class="evaluationCom mainPageBg">
    <div class="dateSelect ashComWrap">
      <DateTypeChange
        :dateList="dateList"
        :selectType="'radio'"
        :showExport="authority"
        style="margin-left: 20px"
        @getDateData="getDateData"
      />
    </div>
    <div class="contentBox">
      <div class="rowBox ashComWrap" v-for="(v, i) in indexList" :key="i">
        <div class="comTitle">
          <h4>{{ v.title }}</h4>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'evaluation' + i"
            :chartsData="v.chartsData"
            :type="'lightLine'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTypeChange from "@/components/DatePicker/DateTypeChange.vue";
import PublicEcharts from "@/components/PublicEcharts.vue";
export default {
  props: {
    authority: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DateTypeChange,
    PublicEcharts,
  },
  data() {
    return {
      dateList: [
        { label: "年", value: "YEAR" },
        { label: "全部", value: "UNLIMITED" },
      ],
      indexList: [
        {
          title: "万元GDP指标",
          chartsData: {
            type: "line",
            unit: "kw·h",
            xData: [],
            dataArr: [],
          },
        },
        {
          title: "单位建筑面积能耗指标",
          chartsData: {
            type: "line",
            unit: "kw·h",
            xData: [],
            dataArr: [],
          },
        },
        {
          title: "单位建筑面积电耗指标",
          chartsData: {
            type: "line",
            unit: "kw·h",
            xData: [],
            dataArr: [],
          },
        },
        {
          title: "人均综合能耗指标",
          chartsData: {
            type: "line",
            unit: "kw·h",
            xData: [],
            dataArr: [],
          },
        },
        {
          title: "人均综合电耗指标",
          chartsData: {
            type: "line",
            unit: "kw·h",
            xData: [],
            dataArr: [],
          },
        },
        {
          title: "人均用水量指标",
          chartsData: {
            type: "line",
            unit: "kw·h",
            xData: [],
            dataArr: [],
          },
        },
      ],
    };
  },
  methods: {
    getDateData(data) {
      // console.log("日月年切换选择", data);
      this.indexList.map((v) => {
        v.chartsData.type = data.timeType == "UNLIMITED" ? "bar" : "line";
        v.chartsData.xData = ["1月", "2月", "3月", "4月", "5月", "6月"];
        v.chartsData.dataArr = [
          { name: "国家指标", data: [18, 18, 18, 18, 18, 18] },
          { name: "基准年2022", data: [7, 9, 16, 22, 16, 14] },
          { name: "2023", data: [5, 7, 14, 20, 14, 12] },
          { name: "单位指标", data: [11, 11, 11, 11, 11, 11] },
        ];
      });
    },
    exportExcel() {},
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.evaluationCom {
  .dateSelect {
    width: 100%;
    height: 60px;
    @include setFlexStart;
  }
  .contentBox {
    width: 100%;
    height: calc(100% - 72px);
    margin-top: 12px;
    overflow: auto;
    @include setFlexStart;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    .rowBox {
      width: calc(33% - 8px);
      height: 300px;
      margin: 0 12px 12px 0;
    }
  }
}
</style>
